import React from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import PropTypes from "prop-types";

const CommonToast = ({ type, message }) => {
  return (
    message && (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        autoHideDuration={2000}
        open={true}
        children={type ? <Alert severity={type}>{message}</Alert> : ""}
      />
      // <Toast
      //   show={true}
      //   align="top"
      //   onClose={()=>console.log("closed")}
      //   type={type}
      //   text={message}
      //   buttonLabel="Top"
      // />
    )
  );
};

CommonToast.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string.isRequired,
};

export default CommonToast;
